import React from 'react';
import { i18n } from 'i18n';
import { Trans } from '@lingui/react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ProgressButton from 'components/ProgressButton';
import DraggableDialog from '../DraggableDialog/DraggableDialog';

interface DxfPreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onRemove: () => void;
  isSaving: boolean;
  error: string | null;
  nodeCount: number;
}

const DxfPreviewDialog: React.FC<DxfPreviewDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  onRemove,
  isSaving,
  error,
  nodeCount,
}) => (
  <DraggableDialog
    isOpen={isOpen}
    title={i18n._('Preview DXF Import')}
    position={{ x: window.innerWidth / 2 - 200, y: window.innerHeight / 2 - 100 }}
    dialogSize={{ width: 400, height: 200 }}
    onClose={onClose}
    onDrag={() => { }}
    onResizeStart={() => { }}
  >
    <Box sx={{ p: 2 }}>
      <Typography variant="body1" gutterBottom>
        <Trans id="Found">Found</Trans>
        {` ${nodeCount} `}
        <Trans id="nodes to import">nodes to import</Trans>
      </Typography>

      {error && (
        <Typography color="error" variant="body2" gutterBottom>
          {error}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <ProgressButton
          variant="contained"
          color="secondary"
          onClick={onSave}
          disabled={isSaving}
        >
          {isSaving ? <Trans id="Saving...">Saving...</Trans> : <Trans id="Save">Save</Trans>}
        </ProgressButton>

        <ProgressButton
          variant="outlined"
          color="error"
          onClick={onRemove}
          disabled={isSaving}
        >
          <Trans id="Remove">Remove</Trans>
        </ProgressButton>
      </Box>
    </Box>
  </DraggableDialog>
);

export default DxfPreviewDialog;
